import React, { useEffect, useState, useRef } from 'react';
/**
 * FillInRenderer — Text/number input for open-ended questions.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 */
import { motion } from 'framer-motion';
import { QuestionRendererProps } from './types';
import { LatexRenderer } from '../../../components/ui/LatexRenderer';
export function FillInRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const [value, setValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const prevValidateRef = useRef(false);
  const config = question.data || {};
  const placeholder = config.placeholder || 'Typ je antwoord...';
  const inputType = config.inputType || 'text';
  const unit = config.unit || '';
  useEffect(() => {
    setValue('');
    prevValidateRef.current = false;
  }, [question.id]);
  useEffect(() => {
    if (!shouldValidate) {
      prevValidateRef.current = false;
    }
  }, [shouldValidate]);
  useEffect(() => {
    onReadyChange?.(value.trim().length > 0);
  }, [value, onReadyChange]);
  useEffect(() => {
    if (shouldValidate && !prevValidateRef.current) {
      prevValidateRef.current = true;
      const answer = inputType === 'number' ? Number(value) : value;
      onAnswer(answer);
    }
  }, [shouldValidate, value, inputType, onAnswer]);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="w-full max-w-md mx-auto" data-id="element-7341">
      <motion.div animate={{
      scale: isFocused ? 1.02 : 1
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 20
    }} className="flex items-center gap-3" data-id="element-7342">
        <input type={inputType === 'number' ? 'number' : 'text'} value={value} onChange={e => setValue(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} placeholder={placeholder} className="flex-1 p-5 text-xl font-medium text-slate-800 border-2 border-slate-200 rounded-2xl focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all shadow-sm" autoFocus data-id="element-7343" />

        {unit && <span className="text-xl font-bold text-slate-500 bg-slate-100 px-4 py-3 rounded-xl" data-id="element-7344">
            <LatexRenderer content={unit} data-id="element-7345" />
          </span>}
      </motion.div>

      <p className="text-center text-slate-400 text-sm mt-6 font-medium" data-id="element-7346">
        {value.length > 0 ? 'Klaar? Klik op Controleren!' : 'Typ je antwoord in het vak hierboven'}
      </p>
    </motion.div>;
}